import React, { useMemo } from 'react';
import DateTimeDisplay from '../DateTimeDisplay';
import { Table } from '../common/Table';

const COLUMNS = [
  { key: 'ipAddress', label: 'IP', sortable: true },
  { key: 'userAgent', label: 'Application', sortable: false },
  { key: 'location', label: 'Location', sortable: false },
  {
    key: 'createdAt',
    label: 'Time',
    sortable: true,
    render: (value, row) =>
      row.createdAt ? (
        <span className="font-medium text-gray-900">
          <DateTimeDisplay value={row.createdAt} />
        </span>
      ) : (
        <span className="text-gray-400">—</span>
      ),
  },
];

export function normalizeLoginHistoryRows(rows) {
  return (rows || []).map((row, index) => ({
    ...row,
    _rowKey: row.uuid || `${row.createdAt || 'na'}-${row.ipAddress || 'ip'}-${index}`,
  }));
}

const LoginHistoryTable = ({
  rows,
  emptyMessage = 'No login history yet. Entries are recorded each time you sign in.',
}) => {
  const data = useMemo(() => normalizeLoginHistoryRows(rows), [rows]);

  return (
    <Table
      columns={COLUMNS}
      data={data}
      rowKey="_rowKey"
      emptyMessage={emptyMessage}
    />
  );
};

export default LoginHistoryTable;
